export const renderMaxCharactersErrorMessage =
	(translate: (key: string) => string) =>
	({ max }: { max: number }) => {
		return `${translate("field-limit-is")} ${max} ${translate("please-reduce")}`;
	};
